module.exports = __webpack_public_path__ + "media/images/new/icons/refresh-5c3da6de64df6bd1a993285a4448ef75.png";